var scope_0 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/677bdfe4e7d158b895cfd9ae87b6211b.js').default;
var scope_1 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/79e1fe2563a4133dfccd3d7d82e142d0.js').default;
var scope_2 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb371b604cd58d6bdc41f05f30d23fb7.js').default;
var scope_3 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_4 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f318d08b4530a7cfbcd5a1ed2966ad55.js').default;
var scope_5 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fd9f60ec9e8d66e12974a3183700d7f7.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5 )
    